// extracted by mini-css-extract-plugin
export var popup__container = "PopupPersonalData-module--popup__container--4cUPt";
export var popup__title = "PopupPersonalData-module--popup__title--gndRt";
export var popup__content = "PopupPersonalData-module--popup__content--EtkCs";
export var popup__contentWrap = "PopupPersonalData-module--popup__contentWrap--37FBC";
export var popup__title_text = "PopupPersonalData-module--popup__title_text--29dP3";
export var popup__content_text = "PopupPersonalData-module--popup__content_text--1PxLI";
export var popup__buttonWrap = "PopupPersonalData-module--popup__buttonWrap--tx7fz";
export var popup__contentButton = "PopupPersonalData-module--popup__contentButton--2fM2J";
export var popup__contentButtonText = "PopupPersonalData-module--popup__contentButtonText--2pXq-";